/**
 * Issue Export functionality for web forms
 * Provides dialog for filtering and exporting issues to Excel
 */

frappe.ready(() => {
	// Only show export button on list view (not on individual doc forms)
	if (!frappe?.web_form?.docname) {
		const listHeader = document.querySelector(".web-list-actions");
		if (listHeader) {
			const exportBtn = document.createElement("button");
			exportBtn.classList.add("btn", "btn-primary", "btn-sm", "mx-2");
			exportBtn.innerText = __("Export Report");
			listHeader.appendChild(exportBtn);

			exportBtn.addEventListener("click", function () {
				showExportDialog();
			});
		}
	}
});

/**
 * Display export dialog with filter options
 */
function showExportDialog() {
	const d = new frappe.ui.Dialog({
		title: __("Export Issues"),
		fields: [
			{
				fieldname: "from_date",
				label: __("From Date"),
				fieldtype: "Date",
				description: ""
			},
			{
				fieldname: "to_date",
				label: __("To Date"),
				fieldtype: "Date",
				description: ""
			},
			{
				fieldname: "status",
				label: __("Status"),
				fieldtype: "Select",
				options: "\nOpen\nReplied\nOn Hold\nUnder Testing\nResolved\nClosed",
				description: ""
			},
			{
				fieldname: "issue_type",
				label: __("Issue Type"),
				fieldtype: "Select",
				options: "\nBug\nEnhancement\nQuery\nQuestion",
				description: "",
				onchange: () => {
					const issue_type = d.get_value("issue_type");
					d.fields_dict["degree_of_danger"].df.hidden = !(issue_type === "Bug");
					d.fields_dict["degree_of_danger"].df.reqd = issue_type === "Bug";
					d.refresh();
				}
			},
			{
				fieldname: "degree_of_danger",
				label: __("Degree of Danger"),
				fieldtype: "Select",
				options: "\nLow\nMedium\nHigh\nUrgent",
				hidden: 1,
				description: ""
			}
		],
		primary_action_label: __("Export"),
		primary_action: (values) => {
			d.hide();
			exportIssuesWithFilters(values);
		}
	});
	d.show();
}

/**
 * Export issues with applied filters
 * @param {Object} filters - Filter values from dialog
 */
function exportIssuesWithFilters(filters) {
	frappe.call({
		method: "stridesupport.api.export_issues_with_filters",
		args: {
			filters: JSON.stringify(filters)
		},
		freeze: true,
		freeze_message: __("Generating Excel file..."),
		callback: function (r) {
			if (!r.exc && r.message) {
				// Validate URL is from same origin (security check)
				const fileUrl = r.message;
				if (isValidFileUrl(fileUrl)) {
					window.open(fileUrl, "_blank");
					frappe.show_alert({
						message: __("Excel file generated successfully"),
						indicator: "green"
					});
				} else {
					frappe.msgprint({
						title: __("Invalid URL"),
						message: __("The file URL received is invalid or not from a trusted source."),
						indicator: "red"
					});
				}
			} else if (!r.message) {
				frappe.msgprint({
					title: __("Export Failed"),
					message: __("No file URL returned. Please try again."),
					indicator: "orange"
				});
			}
		},
		error: function (r) {
			frappe.msgprint({
				title: __("Export Failed"),
				message: __(
					"An error occurred while exporting issues. Please check your filters and try again."
				),
				indicator: "red"
			});
		}
	});
}

/**
 * Validate file URL is from trusted source
 * @param {string} url - URL to validate
 * @returns {boolean} True if URL is valid and safe
 */
function isValidFileUrl(url) {
	if (!url || typeof url !== "string") {
		return false;
	}

	try {
		// Must start with /files/ (Frappe file path) or be a full URL from same origin
		if (url.startsWith("/files/")) {
			return true;
		}

		const urlObj = new URL(url, window.location.origin);
		return urlObj.origin === window.location.origin;
	} catch (e) {
		console.error("Invalid URL:", e);
		return false;
	}
}
